import { Link } from '@tanstack/react-router';
import { ArrowLeft, ShieldAlert } from 'lucide-react';

import { Page, PageHeader } from '@/components/layout/PageHeader';
import { ChangePasswordCard } from '@/components/settings/ChangePasswordCard';
import { buttonVariants } from '@/components/ui/button';
import { useAuthStore } from '@/stores/auth';

export const CHANGE_PASSWORD_PATH = '/settings/change-password';

/**
 * Changement de mot de passe seul. Destination imposée par RequireAuth tant que mustChangePassword est vrai
 * (admin créé par un autre admin) ; sinon accessible depuis /settings.
 */
export const ChangePasswordPage = () => {
  const forced = useAuthStore((s) => Boolean(s.admin?.mustChangePassword));

  return (
    <Page className="max-w-3xl">
      {!forced && (
        <Link to="/settings" className={buttonVariants({ variant: 'ghost', size: 'sm', className: '-ml-3 w-fit text-muted-foreground' })}>
          <ArrowLeft className="mr-1 h-4 w-4" aria-hidden />
          Paramètres
        </Link>
      )}
      <PageHeader title="Changer le mot de passe" />
      {forced && (
        <div
          role="alert"
          data-testid="must-change-password-banner"
          className="flex gap-3 rounded-md border border-warning/40 bg-warning/10 px-4 py-3 text-sm text-amber-800"
        >
          <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <p>
            Votre compte a été créé avec un mot de passe provisoire, connu de l'admin qui l'a créé. Choisissez-en un nouveau avant
            de continuer : les autres pages restent inaccessibles d'ici là.
          </p>
        </div>
      )}
      <ChangePasswordCard />
    </Page>
  );
};
